<template>
  <div v-show="track" class="ml2 mv2 w-100 textColor">
    <p v-show="track.title" class="track-info fw6 lh-title mv0 mw-100 textColor">{{track.title}} </p>
    <router-link v-show="track.artist.name" class="track-info fw4 mt0 mb0 mw-100 textColor"
      :to="{ name: 'artist-info', params: { id: track.artist.id }}">
      {{track.artist.name}}
    </router-link>
  </div>
</template>

<script>
  export default {
    name: 'track-data',
    props: {
      track: {
        required: true
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';
  .track-info {
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    text-decoration: none;
  }

  @media screen and (max-width: 479px) {
    .track-info {
      font-size: .75rem;
      white-space: normal;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tracks/TrackData.vue